import StepTemplate from './StepTemplate.component';

export default StepTemplate;
